<div class="container">
  <div class="settings-container">
    <!-- Report a Bug -->
    <div class="setting-card" id="reportBugCard">
      <div class="card-header">
        <div class="setting-info">
          <div class="setting-icon">
            <!-- icon -->
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                 class="feather feather-alert-triangle">
              <path
                d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
              <line x1="12" y1="9" x2="12" y2="13"></line>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
          </div>
          <div class="setting-details">
            <h3>Report a Bug</h3>
            <p>Help us improve by reporting issues</p>
          </div>
        </div>
        <button class="action-btn" (click)="openReportForm()">Report</button>
      </div>
    </div>

    <!-- 2-Step Verification -->
    <div class="setting-card" id="twoFactorCard">
      <div class="card-header">
        <div class="setting-info">
          <div class="setting-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" fill="none" stroke="currentColor"
                    stroke-width="2"/>
            </svg>
          </div>
          <div class="setting-details">
            <h3>2-Step Verification</h3>
            <p>Add an extra layer of security</p>
          </div>
        </div>
        <div class="toggle-container">
          <label class="toggle-switch">
            <input type="checkbox" [(ngModel)]="twoFactorEnabled" (change)="toggleTwoFactor()"/>
            <span class="toggle-slider"></span>
          </label>
        </div>
      </div>
    </div>

    <!-- Change Password -->
    <div class="setting-card" id="changePasswordCard">
      <div class="card-header">
        <div class="setting-info">
          <div class="setting-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                 class="feather feather-key">
              <path
                d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>
            </svg>
          </div>
          <div class="setting-details">
            <h3>Change Password</h3>
            <p>Update your account password</p>
          </div>
        </div>
        <button class="action-btn" (click)="openModal('changePassword')">Change</button>
      </div>
    </div>

    <!-- Dark Mode -->
    <div class="setting-card" id="darkModeCard">
      <div class="card-header">
        <div class="setting-info">
          <div class="setting-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" fill="none" stroke="currentColor"
                    stroke-width="2"/>
            </svg>
          </div>
          <div class="setting-details">
            <h3>Dark Mode</h3>
            <p>Switch to dark theme</p>
          </div>
        </div>
        <div class="toggle-container">
          <label class="toggle-switch">
            <input type="checkbox" [(ngModel)]="darkModeEnabled" (change)="toggleDarkMode()"/>
            <span class="toggle-slider"></span>
          </label>
        </div>
      </div>
    </div>

    <!-- Invite -->
    <div class="setting-card" id="inviteCard">
      <div class="card-header">
        <div class="setting-info">
          <div class="setting-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M4 4h16v16H4z" fill="none" stroke="currentColor" stroke-width="2"/>
              <path d="M22 6 12 13 2 6" fill="none" stroke="currentColor" stroke-width="2"/>
            </svg>
          </div>
          <div class="setting-details">
            <h3>Invite</h3>
            <p>Invite colleagues to join</p>
          </div>
        </div>
        <button class="action-btn" (click)="openModal('invite')">Invite</button>
      </div>
    </div>

    <!-- Accounts -->
    <div class="setting-card" id="accountsCard">
      <div class="card-header">
        <div class="setting-info">
          <div class="setting-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <circle cx="12" cy="7" r="4" fill="none" stroke="currentColor" stroke-width="2"/>
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" fill="none" stroke="currentColor" stroke-width="2"/>
            </svg>
          </div>
          <div class="setting-details">
            <h3>Accounts</h3>
            <p>Manage your account settings</p>
          </div>
        </div>
        <button class="action-btn" (click)="openModal('accounts')">Manage</button>
      </div>
    </div>
  </div>
</div>

<!-- Change Password Modal -->
<div class="modal" [class.show]="isChangePasswordModalOpen" (click)="closeModal('changePassword')">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Change Password</h2>

      <!-- cierra el modal -->
      <button class="close-btn" (click)="closeModal('changePassword')">×</button>
    </div>

    <div class="modal-body">
      <!-- Reutilizable: formulario de change password -->
      <app-change-password2
        #changePassword
        [presentation]="'modal'"
        (completed)="onChangePwdCompleted()"
        (cancelled)="closeModal('changePassword')">
      </app-change-password2>
    </div>
  </div>
</div>

<!-- Invite Modal -->
<div class="modal" [class.show]="isInviteModalOpen" (click)="closeModal('invite')">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Invitations</h2>
      <button class="close-btn" type="button" (click)="closeModal('invite')">×</button>
    </div>

    <div class="modal-body">
      <!-- Tabs (píldoras) -->
      <div class="tabs-container" role="tablist" aria-label="Invite tabs"
           style="display:flex; gap:8px; margin-bottom:16px;">
        <button
          type="button"
          class="tab-btn"
          role="tab"
          id="invite-tab-add"
          (click)="setInviteTab('add')"
          [class.active]="inviteTab === 'add'"
          [attr.aria-selected]="inviteTab === 'add' ? 'true' : 'false'"
          [attr.tabindex]="inviteTab === 'add' ? '0' : '-1'"
          [attr.aria-controls]="'invite-panel-add'">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
               class="feather feather-user-plus">
            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="8.5" cy="7" r="4"></circle>
            <line x1="20" y1="8" x2="20" y2="14"></line>
            <line x1="23" y1="11" x2="17" y2="11"></line>
          </svg>
          <span>Add New</span>
        </button>

        <button
          type="button"
          class="tab-btn"
          role="tab"
          id="invite-tab-sent"
          (click)="setInviteTab('sent')"
          [class.active]="inviteTab === 'sent'"
          [attr.aria-selected]="inviteTab === 'sent' ? 'true' : 'false'"
          [attr.tabindex]="inviteTab === 'sent' ? '0' : '-1'"
          [attr.aria-controls]="'invite-panel-sent'">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
               class="feather feather-mail">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
          <span>View Sent</span>
        </button>
      </div>

      <!-- Panel: Add Invite -->
      <section
        role="tabpanel"
        id="invite-panel-add"
        [attr.aria-labelledby]="'invite-tab-add'"
        [hidden]="inviteTab !== 'add'">

        <form [formGroup]="inviteForm" (ngSubmit)="submitInvite()">
          <!-- Role -->
          <div class="form-group">
            <label for="inviteRole">Role</label>
            <p-dropdown
              id="inviteRole"
              formControlName="role"
              [options]="resultRole"
              optionLabel="name"
              optionValue="id"
              filterBy="name"
              placeholder="Select a Role"
              [style]="{ width: '100%' }"
              [styleClass]="'input-like'"
              [panelStyleClass]="'dropdown-panel-like'"
              (onChange)="onRoleChange($event)">
            </p-dropdown>
            <div class="field-error" *ngIf="inviteForm.get('role')?.touched && inviteForm.get('role')?.invalid">
              <span>Role is required.</span>
            </div>
          </div>

          <!-- NPI (oculto si selectedRole === '5') -->
          <div class="form-group" *ngIf="selectedRole !== '5'">
            <label for="inviteNpi">NPI</label>
            <p-dropdown
              id="inviteNpi"
              formControlName="npi"
              [options]="npiList"
              optionLabel="name"
              optionValue="npi"
              filterBy="name"
              placeholder="Select a npi"
              [style]="{ width: '100%' }"
              [styleClass]="'input-like'"
              [panelStyleClass]="'dropdown-panel-like'"
              (onChange)="onNpiChange()">
            </p-dropdown>
            <div class="field-error" *ngIf="inviteForm.get('npi')?.touched && inviteForm.get('npi')?.invalid">
              <span>NPI is required.</span>
            </div>
          </div>

          <div class="form-group">
            <input type="text" formControlName="firstName" placeholder="First Name"/>
            <div class="field-error"
                 *ngIf="inviteForm.get('firstName')?.touched && inviteForm.get('firstName')?.invalid">
              <span>First name is required.</span>
            </div>
          </div>

          <div class="form-group">
            <input type="text" formControlName="lastName" placeholder="Last Name"/>
            <div class="field-error" *ngIf="inviteForm.get('lastName')?.touched && inviteForm.get('lastName')?.invalid">
              <span>Last name is required.</span>
            </div>
          </div>

          <div class="form-group">
            <input type="tel" formControlName="phoneNumber" placeholder="Phone Number"/>
            <div class="field-error"
                 *ngIf="inviteForm.get('phoneNumber')?.touched && inviteForm.get('phoneNumber')?.invalid">
              <span>Phone is required.</span>
            </div>
          </div>

          <div class="form-group">
            <input type="email" formControlName="email" placeholder="Email Address"/>
            <div class="field-error" *ngIf="inviteForm.get('email')?.touched && inviteForm.get('email')?.invalid">
              <span *ngIf="inviteForm.get('email')?.errors?.['required']">Email is required.</span>
              <span *ngIf="inviteForm.get('email')?.errors?.['email']">Invalid email.</span>
            </div>
          </div>

          <div class="form-actions">
            <button type="button" class="btn-secondary" (click)="closeModal('invite')" [disabled]="inviteLoading">
              Cancel
            </button>
            <button type="submit" class="btn-primary" [disabled]="inviteLoading">
              <span *ngIf="!inviteLoading">{{ 'GENERAL.SEND_INVITATIONS' | translate }}</span>
              <span *ngIf="inviteLoading">Sending…</span>
            </button>
          </div>
        </form>
      </section>

      <!-- Panel: Sent Invites -->
      <section
        role="tabpanel"
        id="invite-panel-sent"
        [attr.aria-labelledby]="'invite-tab-sent'"
        [hidden]="inviteTab !== 'sent'">

        <div class="table-container invites-grid">
          <app-generic-grid
            [columns]="columns"
            [value]="result.results || []"
            [lazy]="true"
            [rows]="limit"
            [totalRecords]="result.count || 0"
            [paginator]="true"
            [rowClickable]="false"
            dataKey="id"
            [actions]="rowActions"
            [actionsHeader]="''"
            [actionsColWidth]="'64px'"
            (lazyLoad)="lazyLoadData($event)"
            (rowClick)="onRowSelect($event)"
            (actionSelect)="onAction($event)"
          ></app-generic-grid>
        </div>
      </section>


      <ng-template #createdTpl let-row>
        {{ moment(row.created).format('MM-DD-YYYY') }}
      </ng-template>
      <!-- Status con badge -->
      <ng-template #statusTpl let-row>
        <span class="status-badge" [ngClass]="row?.status || 'unknown'">
          {{ row?.status || 'Unknown' }}
        </span>
      </ng-template>
    </div>
  </div>
</div>

<!-- Accounts Modal -->
<div class="modal" [class.show]="isAccountsModalOpen" (click)="closeModal('accounts')">
  <div class="modal-content accounts-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>User Management</h2>
      <button class="close-btn" (click)="closeModal('accounts')">×</button>
    </div>

    <div class="modal-body">
      <!-- Filtro -->
      <div class="filter-container">
        <div class="filter-input">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
          <input
            id="userFilter"
            type="text"
            placeholder="Filter"
            [(ngModel)]="valor"
            (input)="searchPress()"
          />
        </div>
      </div>

      <!-- ✅ Generic Grid para Accounts -->
      <div class="table-container invites-grid">
        <app-generic-grid
          [columns]="accountCols"
          [value]="resultAll.results || []"
          [lazy]="true"
          [rows]="limit"
          [totalRecords]="resultAll.count || 0"
          [paginator]="true"
          [rowClickable]="false"
          dataKey="id"
          [actionsHeader]="''"
          [actionsColWidth]="'88px'"
          (lazyLoad)="onAccountLazy($event)"
          (actionSelect)="onAccountAction($event)"
        ></app-generic-grid>
      </div>

      <!-- 🔹 Templates de celdas -->
      <ng-template #statusToggleTpl let-row>
        <label class="toggle-switch small">
          <input
            #cb
            type="checkbox"
            class="native-checkbox"
            [checked]="!!row?.is_verified"
            (click)="confirmToggle($event, cb, row)"
          />
          <span class="toggle-slider"></span>
        </label>
      </ng-template>
      <ng-template #actionTpl let-row>
        <!-- Vista normal -->
        <ng-container *ngIf="editingRoleId !== row.id; else editRoleTpl">
          <button class="btn-select-role" (click)="startRoleEdit(row)">
            select role
          </button>
        </ng-container>

        <!-- Vista edición -->
        <ng-template #editRoleTpl>
          <div style="display:flex; gap:8px; align-items:center;">
            <p-dropdown
              [options]="resultRole"
              optionLabel="name"
              optionValue="id"
              [(ngModel)]="tempSelectedRoleId"
              [ngModelOptions]="{ standalone: true }"
              placeholder="Select a Role"
              appendTo="body"
              [autoZIndex]="true"
              [baseZIndex]="12000"
              [style]="{ width: '160px' }"
              [styleClass]="'input-like'"
              [panelStyleClass]="'dropdown-panel-like'">
            </p-dropdown>
            <button
              class="icon-btn success"
              (click)="applyRoleEdit()"
              [disabled]="savingRoleId === row.id"
              pTooltip="Save" tooltipPosition="top"
              aria-label="Save">
              <i class="pi" [ngClass]="savingRoleId === row.id ? 'pi-spinner pi-spin' : 'pi-check'"></i>
            </button>

            <!-- Cancelar -->
            <button
              class="icon-btn"
              (click)="cancelRoleEdit()"
              [disabled]="savingRoleId === row.id"
              pTooltip="Cancel" tooltipPosition="top"
              aria-label="Cancel">
              <i class="pi pi-times"></i>
            </button>
          </div>
        </ng-template>
      </ng-template>



      <ng-template #lastLoginTpl let-row>
        {{ moment(row.last_login).format('MM-DD-YYYY') }}
      </ng-template>
    </div>
  </div>
</div>

